import { showMessage } from 'app/store/actions/fuse';
import axios from 'api';
import { getCurrentApiUrl } from 'app/helpers';
import i18n from 'i18next';
import { getHairdressers, resetHairdressers } from './hairdressers.actions';

require('dotenv').config();

export const GET_HAIRDRESSER = '[CONSOLE] GET SALON';
export const GET_HAIRDRESSER_STATS_VISIT = '[CONSOLE] GET SALON STATS VISIT';
export const GET_HAIRDRESSER_STATS_REFERER =
  '[CONSOLE] GET SALON STATS REFERER';
export const GET_HAIRDRESSER_STATS_REFERER_KEYWORDS =
  '[CONSOLE] GET SALON STATS REFERER KEYWORDS';
export const SET_ID_MODAL_ACCOUNT = '[CONSOLE] SET_ID_MODAL_ACCOUNT';
export const SET_ID_MODAL_CONTACT = '[CONSOLE] SET_ID_MODAL_CONTACT';
export const SET_ID_MODAL_CREATION_EMAIL =
  '[CONSOLE] SET_ID_MODAL_CREATION_EMAIL';
export const SET_ID_MODAL_EMAIL = '[CONSOLE] SET_ID_MODAL_EMAIL';
export const SET_ID_MODAL_PRICES = '[CONSOLE] SET_ID_MODAL_PRICES';
export const SET_MINISITE = '[CONSOLE] SET MINISITE';

export function setIdModalAccount(id) {
  return {
    type: SET_ID_MODAL_ACCOUNT,
    id_modal_account: id
  };
}

export function setIdModalContact(id) {
  return {
    type: SET_ID_MODAL_CONTACT,
    id_modal_contact: id
  };
}

export function setIdModalEmail(id) {
  return {
    type: SET_ID_MODAL_EMAIL,
    id_modal_email: id
  };
}

export function setIdModalCreationEmail(id) {
  return {
    type: SET_ID_MODAL_CREATION_EMAIL,
    id_modal_creation_email: id
  };
}

export function setIdModalPrices(id) {
  return {
    type: SET_ID_MODAL_PRICES,
    id_modal_prices: id
  };
}

// CREATE EMAIL + USER
export function createUserHairdresser(hairdresser_id, data) {
  return dispatch => {
    axios
      .post(`${getCurrentApiUrl()}/users/hairdresser/${hairdresser_id}`, data)
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.creation.success_message_created', {
              entity: i18n.t('form:user.label.user')
            })
          })
        );
      })
      .catch(err => {
        const isEmailAlreadyExists =
          (err.response && err.response.status === 409) ||
          (err.response && err.response.status === 401 && err.response.data === 'Email already exists');
      
        if (isEmailAlreadyExists) {
          dispatch(
            showMessage({
              message: i18n.t('action.error_email_already_exists')
            })
          );
        } else {
          dispatch(
            showMessage({
              message: i18n.t('action.error')
            })
          );
        }
      });      
  };
}

// REGENERATE EMAIL
export function regenerateEmailHairdresser(hairdresser_id, data) {
  return dispatch => {
    axios
      .post(
        `${getCurrentApiUrl()}/hairdressers/${hairdresser_id}/mailbox/regen`,
        data
      )
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.modify.modify_success', {
              entity: i18n.t('form:user.label.user')
            })
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

// UPDATE USER + EMAIL
export function updatePasswordHairdresser(hairdresser_owner_id, data) {
  return dispatch => {
    axios
      .put(`${getCurrentApiUrl()}/users/${hairdresser_owner_id}/password`, data)
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.modify.modify_several_success')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function sendEmailPdfMiniste(id, formData) {
  return dispatch => {
    axios
      .post(`${getCurrentApiUrl()}/hairdresser/email/minisite/${id}`, formData)
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.hairdresser.email_send')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function getHairdresser(id) {
  const request = axios.get(`${getCurrentApiUrl()}/hairdressers/${id}`, {});

  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function sendEmails(id, message) {
  return dispatch => {
    axios
      .post(`${getCurrentApiUrl()}/hairdresser/emails/${id}`, message)
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.emails_send') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function deleteHairdresser(id, navigate) {
  return dispatch => {
    axios
      .delete(`${getCurrentApiUrl()}/hairdresser/${id}`, {})
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.delation.deletion_success') })
        );
        dispatch(getHairdressers());
        navigate('/hairdressers');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function addHairdresser(params, navigate) {
  return dispatch => {
    axios
      .post(`${getCurrentApiUrl()}/hairdressers`, params, {})
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.creation.creation_success') })
        );
        navigate('/hairdressers');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function saveHairdresser(params, navigate) {
  return dispatch => {
    axios
      .put(`${getCurrentApiUrl()}/hairdressers/${params.id}`, params, {})
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.modify.success_message_updated', {
              entity: i18n.t('hairdressers.hairdresser')
            })
          })
        );
        dispatch(getHairdresser(params.id));
        navigate('/hairdressers');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function setHairdresserAnimator(hairdresser_id, animator_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/hairdresser_animator/${hairdresser_id}/${animator_id}`,
        {}
      )
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.modify.modify_several_success')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function setHairdresserFranchise(hairdresser_id, franchise_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/hairdresser_franchise/${hairdresser_id}/${franchise_id}`,
        {}
      )
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.modify.modify_several_success')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function setHairdresserCoordinator(hairdresser_id, coordinator_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/hairdresser_coordinator/${hairdresser_id}/${coordinator_id}`,
        {}
      )
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.modify.modify_several_success')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function setHairdresserEvents(params, hairdresser) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/minisite/update/${hairdresser.id}`,
        params,
        {}
      )
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: response.data
        });
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

// MINISITE PART
export function updateHours(data, hairdresser_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/minisite/hours/${hairdresser_id}`,
        data
      )
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.hours_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function addEvent(data, hairdresser_id) {
  return dispatch => {
    axios
      .post(`${getCurrentApiUrl()}/hairdressers/${hairdresser_id}/events`, data)
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.creation.creation_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function updateEvent(data, hairdresser_id, idEvent) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdressers/${hairdresser_id}/events/${idEvent}`,
        data
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.modify.modify_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function deleteEvent(hairdresser_id, event_id, refetchEvent) {
  return dispatch => {
    axios
      .delete(
        `${getCurrentApiUrl()}/hairdressers/${hairdresser_id}/events/${event_id}`,
        {}
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.deletion.deletion_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function addPicture(data, id) {
  return dispatch => {
    axios
      .post(`${getCurrentApiUrl()}/hairdressers/${id}/pictures`, data)
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.picture_add') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function updatePicture(data, hairdresser_id, picture_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdressers/${hairdresser_id}/pictures/${picture_id}`,
        data
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.upload_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function deletePicture(hairdresser_id, picture_id) {
  return dispatch => {
    axios
      .delete(
        `${getCurrentApiUrl()}/hairdressers/${hairdresser_id}/pictures/${picture_id}`,
        {}
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.delation.deletion_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function orderPictures(hairdresser_id, arrayOrder) {
  return dispatch => {
    axios
      .post(
        `${getCurrentApiUrl()}/hairdresser/minisite/pictures/order/${hairdresser_id}`,
        arrayOrder
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(showMessage({ message: i18n.t('order_save') }));
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

// parameters
export function updateParameters(data, id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/minisite/parameters/update/${id}`,
        data
      )
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.parameters_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

// hairdresser
export function updateHaidresserWelcomeMessages(data, id) {
  return dispatch => {
    axios
      .put(`${getCurrentApiUrl()}/hairdresser/welcome_message/${id}`, data)
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.data_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

// offers
export function updateOffer(data, hairdresser_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/minisite/offers/${hairdresser_id}`,
        data
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.offer_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function addOffer(data, hairdresser_id) {
  return dispatch => {
    axios
      .post(
        `${getCurrentApiUrl()}/hairdresser/minisite/offers/${hairdresser_id}`,
        data
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.offer_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function deleteOffer(hairdresser_id, offer_id) {
  return dispatch => {
    axios
      .delete(
        `${getCurrentApiUrl()}/hairdresser/minisite/offers/${hairdresser_id}/${offer_id}`,
        {}
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.hairdresser.deletion_success')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

// prices
export function updatePrice(data, hairdresser_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/minisite/prices/${hairdresser_id}`,
        data
      )
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.price_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function updateSpecificPrice(data, hairdresser_id) {
  return dispatch => {
    axios
      .put(
        `${getCurrentApiUrl()}/hairdresser/minisite/specific_price/${hairdresser_id}`,
        data
      )
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.price_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function addSpecificPrice(data, hairdresser_id) {
  return dispatch => {
    axios
      .post(
        `${getCurrentApiUrl()}/hairdresser/minisite/specific_price/${hairdresser_id}`,
        data
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({ message: i18n.t('action.hairdresser.price_save') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function deleteSpecificPrice(hairdresser_id, id) {
  return dispatch => {
    axios
      .delete(
        `${getCurrentApiUrl()}/hairdresser/minisite/specific_price/${hairdresser_id}/${id}`
      )
      .then(res => {
        dispatch({
          type: GET_HAIRDRESSER,
          payload: res.data
        });
      })
      .then(res => {
        dispatch(
          showMessage({
            message: i18n.t('action.hairdresser.deletion_success')
          })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
  };
}

export function getStatsReferersKeywordsHairdresser(id, year) {
  const request = axios.get(
    `${getCurrentApiUrl()}/hairdresser/stats/referer_keyword/${id}?year=${year}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSER_STATS_REFERER_KEYWORDS,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getStatsReferersHairdresser(id, year) {
  const request = axios.get(
    `${getCurrentApiUrl()}/hairdresser/stats/referer/${id}?year=${year}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSER_STATS_REFERER,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getStatsVisitsHairdresser(id, year) {
  const request = axios.get(
    `${getCurrentApiUrl()}/hairdresser/stats/visits/${id}?year=${year}`,
    {}
  );
  return dispatch => {
    request
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSER_STATS_VISIT,
          payload: response.data
        });
      })
      .catch(err => err);
  };
}
